import { render, staticRenderFns } from "./PlanoSafra.vue?vue&type=template&id=644f60e3&scoped=true"
import script from "./PlanoSafra.vue?vue&type=script&lang=js"
export * from "./PlanoSafra.vue?vue&type=script&lang=js"
import style0 from "./PlanoSafra.vue?vue&type=style&index=0&id=644f60e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644f60e3",
  null
  
)

export default component.exports